module.exports = new __parcel__URL__("three-avatars.04f58c3f.svg").toString();